var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('h1', {
    staticClass: "mb-16"
  }, [_vm._v("Thank you for your Service!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "button--filled mt-24 mb-8 px-16 sm:w-full",
    on: {
      "click": function ($event) {
        return _vm.$emit('continue');
      }
    }
  }, [_vm._v("\n\t\t\tContinue\n\t\t")]), _vm._v(" "), _c('DisclosureFooter')], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('p', {
    staticClass: "text-2xl leading-9"
  }, [_vm._v("\n\t\t\tYour military status has placed you in a higher spend power! Spend Power is your highest\n\t\t\tpossible spend limit, see\n\t\t\t"), _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "/legal/terms",
      "target": "_blank"
    }
  }, [_vm._v("terms")]), _vm._v(" for full details. You can\n\t\t\tview your available spend power in the app. (make sure to download it after! 😉)\n\t\t")]);
}];
export { render, staticRenderFns };